import React, { useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import _ from 'lodash'
import axios from 'axios'
import moment from 'moment'
import validate from 'validate.js'
import DatePicker from 'react-datepicker'

import config from '@/config/config-esm'

import { setFormData } from '@/store/slices/formDataSlice'

import PowerPlans from '@/components/MainFlow/AddSubscriptions/AddPowerItem/PowerPlans'
// import Campaigns from '@/components/MainFlow/AddSubscriptions/AddPowerItem/campaigns'
// import ExtraServices from '@/components/MainFlow/AddSubscriptions/AddPowerItem/extra-services'
// import ExtraAbroadCountry from '@/components/MainFlow/AddSubscriptions/AddPowerItem/extra-services/extra-abroad-country'

const constraints = {
  birthDate: {
    format: {
      pattern: /^([012][0-9]\.[01][0-9]\.[12][0-9][0-9][0-9])$/,
    },
    length: {
      is: 10,
    },
  },
}

const defaultItem = {}

const AddPowerItemComponent = ({ editIndex, powerPlans, onClose }) => {
  const dispatch = useDispatch()
  const user = useSelector((state) => state.user)
  const formData = useSelector((state) => state.formData)
  const layout = useSelector((state) => state.layout)
  
  const existingItem =
    typeof editIndex === 'number' ? formData.powerItems[editIndex] : null
  const initialDob =
    existingItem && existingItem.dateOfBirth
      ? moment(existingItem.dateOfBirth).format('DD.MM.YYYY')
      : ''
      
  const [showAddOnModal, setShowAddOnModal] = useState(false)
  const [item, setItem] = useState(existingItem || defaultItem)
  const [dob, setDob] = useState(initialDob)
  const [errors, setErrors] = useState({})
  const [valid, setValid] = useState({})

  const allowSave = () => {
    return Boolean(item.planId && item.firstName && item.lastName && item.email && item.dateOfBirth)
  }

  const changePlan = (planId) => {
    // const { dispatch } = this.props
    // dispatch(setFormData({product: subscriptionId, campaigns: [], extraServices: []}))
    // this.getSubscriptionsExtraServices(subscriptionId)
    setItem({ ...item, planId })
  }

  const addItem = () => {
    let powerItems
    if (typeof editIndex === 'number') {
      powerItems = formData.powerItems
        .slice(0, editIndex)
        .concat([item])
        .concat(formData.powerItems.slice(editIndex + 1))
    } else {
      powerItems = formData.powerItems.concat([item])
    }
    dispatch(setFormData({ powerItems, newPowerSession: false }))
    onClose()
  }

  const close = () => {
    dispatch(setFormData({ newPowerSession: false }))
    onClose()
  }

  const { departmentId } = layout.data

  return powerPlans.length > 0 ? (
      <div>
        <div>
          {config.showingDebugInfo && (
            <div className="debug_element">
              <h2>Item</h2>
              <pre>{JSON.stringify(item, null, 2)}</pre>
            </div>
          )}
          <PowerPlans item={item} plans={powerPlans} changePlan={changePlan} />

          {item.planId && (
            <div style={{ marginBottom: '1rem' }}>
              <h1>Personalia for abonnent</h1>
              <div className="input_wrapper">
                <label htmlFor="firstName">Fornavn:</label>
                <input
                  type="text"
                  id="firstName"
                  value={item.firstName || ''}
                  onChange={(e) => {
                    setItem({ ...item, firstName: e.target.value })
                  }}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="lastName">Etternavn:</label>
                <input
                  type="text"
                  id="lastName"
                  value={item.lastName || ''}
                  onChange={(e) => {
                    setItem({ ...item, lastName: e.target.value })
                  }}
                />
              </div>
              <div className="input_wrapper">
                <label htmlFor="email">Epost:</label>
                <input
                  type="text"
                  id="email"
                  value={item.email || ''}
                  onChange={(e) => {
                    setItem({ ...item, email: e.target.value })
                  }}
                />
              </div>
              <div
                className={`input_wrapper ${errors && errors.dateOfBirth ? 'error' : ''} ${valid && valid.dateOfBirth ? 'validated' : ''}`}
              >
                <label htmlFor="dateOfBirth">Fødselsdato:</label>
                <input
                  id="dateOfBirth"
                  placeholder="01.22.1974"
                  value={dob || ''}
                  onChange={(e) => {
                    const value = e.target.value
                    const dateOfBirth = moment.utc(value, 'DD.MM.YYYY').toISOString()
                    setDob(value)
                    setItem({ ...item, dateOfBirth })
                  }}
                  onBlur={(e) => {
                    setErrors(validate({ dateOfBirth: item.dateOfBirth }, constraints))
                  }}
                  onKeyUp={(e) => {
                    const value = e.target.value

                    if (value.length === 10) {
                      setValid({ dateOfBirth: true })
                      setErrors(validate({ dateOfBirth: item.dateOfBirth }, constraints))
                    } else {
                      setValid({ dateOfBirth: true })
                      setErrors(validate({ dateOfBirth: item.dateOfBirth }, constraints))
                    }
                    const dateOfBirth = moment.utc(value, 'DD.MM.YYYY').toISOString()
                    setDob(value)
                    setItem({ ...item, dateOfBirth })
                  }}
                />
              </div>

              <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                <h1>Strømmåler</h1>
                <div className="input_wrapper">
                  <label htmlFor="email">Målepunkt-ID:</label>
                  <input
                    type="text"
                    id="powerMeterId"
                    value={item.powerMeterId || ''}
                    onChange={(e) => {
                      setItem({ ...item, powerMeterId: e.target.value })
                    }}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="buttons">
            <button className="cancel" onClick={close}>
              Avbryt
            </button>
            <button className="continue" onClick={addItem} disabled={!allowSave()}>
              Lagre
            </button>
          </div>
        </div>
      </div>
    ) : (
      <div />
    )
}

export default AddPowerItemComponent
